import { useRef } from 'react';

import debounce from '@mui/utils/debounce';
import { AxiosResponse } from 'axios';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useDreConfigConfiguracoesContext, useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';

export function useSortConfiguracoes() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<DreConfiguracao>>();
    const { activeGrupo } = useDreConfigContext();
    const { configuracoes, setConfiguracoes } = useDreConfigConfiguracoesContext();
    const { showError } = useShowError();

    /**
     * Retorna um objeto com a sequência das configurações.
     */
    const getSortConfiguracoes = (newConfiguracoes: DreConfiguracao[]) => {
        const order: Record<number, number> = {};

        newConfiguracoes.forEach((configuracao) => {
            order[configuracao.idDreMercadologicaConfiguracao] = configuracao.nrSequencia;
        });

        return order;
    };

    /**
     * useRef para armazenar a função debounced que realiza a request.
     */
    const debouncedUpdateSortRef = useRef(
        debounce((newConfiguracoes: DreConfiguracao[]) => {
            mutate(
                {
                    formData: getSortConfiguracoes(newConfiguracoes),
                    method: 'PUT',
                    url: `/dre/dremercadologicaconfiguracao/ordenacao?idDreMercadologicaTipoGrupoExibicao=${activeGrupo?.idDreMercadologicaTipoGrupoExibicao}`,
                    preventSnack: true,
                    preventRedirect: true,
                },
                {
                    onError: (error) => {
                        setConfiguracoes(configuracoes);
                        showError(error, 'Falha ao ordenar configurações');
                    },
                },
            );
        }, 750),
    );

    /**
     * Faz request para atualizar a sequência dos subgrupos com a função debounced.
     */
    const updateSort = (newConfiguracoes: DreConfiguracao[]) => {
        debouncedUpdateSortRef.current(newConfiguracoes);
    };

    return { updateSort, isLoading };
}
